import * as React from 'react'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type TipPresetProps = React.HTMLAttributes<HTMLDivElement> & {
  amount: React.ReactNode
  checked: boolean
  id: string
  name: string
  onChange: () => void
}

export function TipPreset({ amount, checked, id, name, onChange }: TipPresetProps): React.ReactElement<TipPresetProps> {
  return (
    <InputRadioWrapper data-testid="component:tip.preset">
      <RadioInput type="radio" checked={checked} id={id} name={name} onChange={onChange} onClick={onChange} />
      <RadioLabel htmlFor={id}>
        <Amount checked={checked}>{amount}</Amount>
      </RadioLabel>
    </InputRadioWrapper>
  )
}

const Amount = styled(plume.styles.heading.XXXS)<{ checked?: boolean }>`
  ${({ checked = false, theme }) => {
    if (checked) {
      return css`
        color: ${theme?.colors?.primary ?? plume.COLORS.PRIMARY_BLUE_500};
      `
    }
  }};
`

// FIXME: Put input in label instead?
export const InputRadioWrapper = styled.div`
  min-height: 50px;
  min-width: 60px;
  flex-grow: 1;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    width: calc(31% - 5px);
  }
`

const RadioInput = styled.input`
  display: none;

  &:checked + label {
    border-color: ${({ theme }) => `${theme?.colors?.primary ?? plume.COLORS.PRIMARY_BLUE_500}`};
  }
`

const RadioLabel = styled.label`
  border: 1px solid ${plume.COLORS.GREY_SHADE_5};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  box-sizing: border-box;
  transition: 0.3s ease;
  line-height: 50px;
  border-radius: 2px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    &:hover {
      border-color: ${({ theme }) => `${theme?.colors?.primary ?? plume.COLORS.PRIMARY_BLUE_500}`};
      cursor: pointer;
    }
  }
`
